import React from "react";

import {
    User,
    Phone,
    Mail,
    MapPin,
    Calendar,
    Droplets,
    ShieldCheck
} from "lucide-react";

import "./PersonalInfo.css";

function PersonalInfo({ profile }) {

    const fullAddress = [

        profile?.address?.houseNumber,
        profile?.address?.street,
        profile?.address?.area,
        profile?.address?.landmark,
        profile?.address?.city,
        profile?.address?.state,
        profile?.address?.pincode

    ].filter(Boolean).join(", ");

    const info = [

        {
            icon: <User />,
            title: "Full Name",
            value: profile?.name || "-"
        },

        {
            icon: <Phone />,
            title: "Mobile Number",
            value: profile?.phone || "-"
        },

        {
            icon: <Mail />,
            title: "Email Address",
            value: profile?.email || "-"
        },

        {
            icon: <MapPin />,
            title: "Permanent Address",
            value: fullAddress || "Not Added",
            full: true
        },

        {
            icon: <Calendar />,
            title: "Date of Birth",
            value: profile?.dateOfBirth || "Not Added"
        },

        {
            icon: <Droplets />,
            title: "Blood Group",
            value: profile?.bloodGroup || "Not Added"
        },

        {
            icon: <ShieldCheck />,
            title: "Emergency Contact",
            value: profile?.emergencyContact || "Not Added"
        }

    ];

    return (

        <div className="hf-personal-card">

           <div className="hf-personal-header">

                <div>

                    <h2>

                        Personal Information

                    </h2>

                    <p>

                        Your registered personal details

                    </p>

                </div>

            </div>

           <div className="hf-personal-grid">

                {

                    info.map((item,index)=>(

                        <div

                            key={index}

                           className={`hf-personal-item ${item.full ? "hf-personal-full" : ""}`}
                        >

                            <div className="hf-personal-icon">

                                {item.icon}

                            </div>

                           <div className="hf-personal-content">

                                <span>

                                    {item.title}

                                </span>

                                <h4>

                                    {item.value}

                                </h4>

                            </div>

                        </div>

                    ))

                }

            </div>

        </div>

    );

}

export default PersonalInfo;